import moment from 'moment';

export { poi };

const poi = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'poiTotalCount', header: 'Total POI' },
          { field: 'poiTotalTime', header: 'Total Time' }
        ],
      },
      pdf: {
        title: 'POI - Summary',
        colsWidth: [80, 70, 70],
      },
    },
    {
      label: 'Breakdown',
      icon: 'event',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'poiName', header: 'POI Name' },
          { field: 'poiType', header: 'Type',visible:false },
          { field: 'time', header: 'Time' },
          { field: 'duration', header: 'Duration' },
        ],
      },
      pdf: {
        title: 'POI - Breakdown',
        colsWidth: [101, 101, 70, 70, 70],
      },
    }
  ];
};
